/*
 * File: useInput.ts
 * Project: a-a
 * File Created: Wednesday, 16th October 2024 7:25:59 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 27th May 2025 12:25:36 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { useEffect, useState } from 'react';

export const useInput = (
  defaultValue: string,
  validFn: (text: string) => boolean | string,
  done = false,
  setDone?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState('');
  const [didChange, setDidChange] = useState(false);

  useEffect(() => {
    !value && setValue('');
  }, []);
  useEffect(() => {
    done && setDidChange(false);
  }, [done]);
  // console.log(validFn)
  let invalid = !validFn(value || '');

  const handleBlur = () => {
    setDidChange(true);
  };
  const clearInput = () => {
    setValue('');
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError('');
    setDidChange(true);
    setValue(event.target.value);
    if (done && setDone) {
      setDone(false);
      // setDidChange(true);
    }
  };
  return {
    handleChange,
    handleBlur,
    value,
    error,
    setError,
    invalid,
    didChange,
    clearInput,
    setValue,
    setDidChange,
  };
};
